import React from 'react';

const styles = {
  fontSize: 20,
  padding: '106px 0',
  fontWeight: 500,
  backgroundColor: '#fff',
  marginBottom: 20,
};

const iconStyle = {
  fontSize: 35,
  marginBottom: 18,
};

const ErrorPaquete = (props) => {
  const mensaje = props.mensaje ? props.mensaje : 'No pudimos encontrar el paquete solicitado.';
  return (
    <div style={{ backgroundColor: '#eaeaea', paddingTop: 20 }}>
      <div className='container'>
        <div className='clearfix' />
        <div className='row'>
          {/* <div className="col-lg-3"> */}
          {/* <BuscadorVertical/> */}
          {/* </div> */}
          <div className='col-lg-12'>
            <div className='color-dinamico text-center' style={styles}>
              <div className='icono' style={iconStyle}>
                <i className='fa fa-exclamation-circle' />
              </div>
              {mensaje}
              <br />
              <br />
              <br />
              <div className='text-center' style={{ textDecoration: 'underline' }}>
                <a href={process.env.RAZZLE_URL_PATH}> Volver a Inicio</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPaquete;
